import * as React from 'react';

function PaymentDiary(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="126" height="126" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_11045_44814)">
        <path
          d="M21.0501 31.2C18.5438 31.2 16.1402 32.1956 14.3679 33.9678C12.5957 35.74 11.6001 38.1437 11.6001 40.65V84.75C11.6001 87.2562 12.5957 89.6599 14.3679 91.4321C16.1402 93.2043 18.5438 94.1999 21.0501 94.1999H90.3501C92.8564 94.1999 95.26 93.2043 97.0323 91.4321C98.8045 89.6599 99.8001 87.2562 99.8001 84.75V40.65C99.8001 38.1437 98.8045 35.74 97.0323 33.9678C95.26 32.1956 92.8564 31.2 90.3501 31.2H21.0501ZM36.8001 37.5V43.8C36.8001 47.1417 35.4726 50.3465 33.1096 52.7095C30.7467 55.0725 27.5418 56.4 24.2001 56.4H17.9001V50.1H24.2001C25.871 50.1 27.4734 49.4362 28.6549 48.2547C29.8363 47.0732 30.5001 45.4708 30.5001 43.8V37.5H36.8001ZM55.7001 73.7249C52.7761 73.7249 49.9718 72.5634 47.9042 70.4958C45.8367 68.4282 44.6751 65.624 44.6751 62.6999C44.6751 59.7759 45.8367 56.9717 47.9042 54.9041C49.9718 52.8365 52.7761 51.6749 55.7001 51.6749C58.6241 51.6749 61.4284 52.8365 63.4959 54.9041C65.5635 56.9717 66.7251 59.7759 66.7251 62.6999C66.7251 65.624 65.5635 68.4282 63.4959 70.4958C61.4284 72.5634 58.6241 73.7249 55.7001 73.7249ZM17.9001 75.2999V69H24.2001C27.5418 69 30.7467 70.3274 33.1096 72.6904C35.4726 75.0534 36.8001 78.2582 36.8001 81.5999V87.8999H30.5001V81.5999C30.5001 79.9291 29.8363 78.3267 28.6549 77.1452C27.4734 75.9637 25.871 75.2999 24.2001 75.2999H17.9001ZM87.2001 75.2999C85.5292 75.2999 83.9268 75.9637 82.7453 77.1452C81.5638 78.3267 80.9001 79.9291 80.9001 81.5999V87.8999H74.6001V81.5999C74.6001 78.2582 75.9276 75.0534 78.2906 72.6904C80.6535 70.3274 83.8584 69 87.2001 69H93.5001V75.2999H87.2001ZM87.2001 50.1H93.5001V56.4H87.2001C83.8584 56.4 80.6535 55.0725 78.2906 52.7095C75.9276 50.3465 74.6001 47.1417 74.6001 43.8V37.5H80.9001V43.8C80.9001 45.4708 81.5638 47.0732 82.7453 48.2547C83.9268 49.4362 85.5292 50.1 87.2001 50.1ZM106.1 84.75C106.1 88.9271 104.441 92.9332 101.487 95.8869C98.5333 98.8406 94.5273 100.5 90.3501 100.5H24.7356C25.3873 102.343 26.5946 103.939 28.1912 105.067C29.7878 106.196 31.695 106.801 33.6501 106.8H90.3501C96.1981 106.8 101.807 104.477 105.942 100.342C110.077 96.2065 112.4 90.598 112.4 84.75V53.25C112.401 51.2949 111.796 49.3876 110.667 47.7911C109.539 46.1945 107.943 44.9871 106.1 44.3355V84.75Z"
          fill="#DADADA"
        />
        <circle cx="101" cy="88" r="16" fill="white" stroke="#DADADA" stroke-width="4" />
        <g clip-path="url(#clip1_11045_44814)">
          <path
            d="M96.1875 88H105.813"
            stroke="#DADADA"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M101 83.1875V92.8125"
            stroke="#DADADA"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11045_44814">
          <rect width="126" height="126" fill="white" />
        </clipPath>
        <clipPath id="clip1_11045_44814">
          <rect width="14" height="14" fill="white" transform="translate(94 81)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PaymentDiary;
